<div class='page-header' [style.backgroundColor]=colorHex>
  <div class='header'>
    <div class='left'>
      <img class='logo' [hidden]='backName' src='assets/imgs/music-together-logo.png' (click)='commands.gotoMusicTogether()'>
      <button [hidden]='!backName' (click)='commands.popPage(backName)'><i class='mt-left'></i>{{width > 440 ? 'Back to ' : ''}}{{backName}}</button>
    </div>

    <button class='update-available' [hidden]='!updateProvider.hasUpdate' (click)='commands.update()'><i class='mt-alert'></i>{{width > 375 ? 'Click to Update' : 'Update'}}</button>

    <div class='right' [hidden]='width < 650'>
      <button [ngClass]='{"underlined": isLessonPlans}' (click)='commands.gotoLessonPlansPage()'>Lesson Plans</button>
      <button (click)='presentResourcesMenu($event)'>Resources</button>
      <button [ngClass]='{"underlined": isTeacherNotes || isBlog}' (click)='commands.gotoTeacherNotesPage()'>Teacher Blog</button>

      <ng-container *ngFor='let page of topLevelNav(); trackBy:trackByUuid'>
        <button [ngClass]='{"underlined": isPages && isCurrentPage(page.slug)}' (click)='commands.gotoPagesPage(null, page)'>{{page.title}}</button>
      </ng-container>
      
      <button (click)='presentUserMenu($event)'><i class="mt-user"></i></button>
      <button (click)='presentUserMenu($event)'><i class="mt-arrow-down"></i></button>
    </div>

    <div class='mobile' [hidden]='width >= 650'>
      <button class='responsive-menu-button' (click)='presentResponsivePageMenu($event)'><i class="mt-grab"></i></button>
    </div>
  </div>
</div>

<ion-menu menuId="responsive-menu" class='responsive-menu' type='overlay' side='end' draggable="false">
  <ion-content>
   <app-responsive-menu></app-responsive-menu>
  </ion-content>
</ion-menu>
<app-cache-notification></app-cache-notification>